import { ListRowLabel, ListRowValue, RXCell } from 'components/RXTable'
import styled from 'styled-components'
import { contrastBackgroundColor } from 'styles/styleVariables'
import type { CopayRequest } from 'types'
import { checkIfProvided, formatPhoneNumber } from 'utils'

const StyledContacts = styled.ul`
  margin-top: 0.625rem;
  > :nth-child(2n) {
    background-color: ${contrastBackgroundColor};
  }
`

const StyledRXCell = styled(RXCell)`
  grid-template-columns: [label] 6rem [value] 1fr;
  padding-left: 0.625rem;
`

type CopayPatientContactsProps = {
  patientContacts?: CopayRequest['patientContacts']
}

/**
 * Email and phone the customer sent with the copay request. Shown next to the patient profile
 * because the profile's contacts may be empty or different (e.g. to enroll the patient on GoodRx).
 */
const CopayPatientContacts = ({ patientContacts }: CopayPatientContactsProps): JSX.Element | null => {
  if (!patientContacts?.email && !patientContacts?.phone) return null

  return (
    <StyledContacts data-testid="CopayPatientContacts">
      <StyledRXCell data-test-row="copay-contact-phone">
        <ListRowLabel>Req. phone:</ListRowLabel>
        <ListRowValue data-private>{checkIfProvided(formatPhoneNumber(patientContacts.phone))}</ListRowValue>
      </StyledRXCell>
      <StyledRXCell data-test-row="copay-contact-email">
        <ListRowLabel>Req. email:</ListRowLabel>
        <ListRowValue data-private>{checkIfProvided(patientContacts.email)}</ListRowValue>
      </StyledRXCell>
    </StyledContacts>
  )
}

export default CopayPatientContacts
